import React, { useContext } from 'react';
import { Link, useHistory, NavLink } from 'react-router-dom';
import { Auth } from 'aws-amplify'

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Navbar, Nav, Offcanvas, Button } from 'react-bootstrap';

import UserContext from './../../app/UserContext'
import { SIGN } from './../../shared/constants/index'


/**
 * ナビゲーション
 * @returns 
 */
export const NavItems = () => (
    <nav className="sidebar">
      <div className="nav-section">ナビゲーション</div>
      <Nav className="flex-column">
        <Nav.Item>
          <NavLink exact to="/dashboard" className="nav-link">
            ダッシュボード
          </NavLink>
        </Nav.Item>
      </Nav>

      <hr className="nav-separator" />
      <div className="nav-section">データ</div>
      <Nav className="flex-column">
        <Nav.Item>
          <NavLink to="/users" className="nav-link">
            ユーザ一覧
          </NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink to="/licences" className="nav-link">
            ライセンス一覧
          </NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink to="/versions" className="nav-link">
            バージョン一覧
          </NavLink>
        </Nav.Item>
      </Nav>

      <hr className="nav-separator" />

  </nav>
);

/**
 *  Offcanvasサイドバー
 */
export const SidebarOffcanvas = ({ show, onHide }) => (
  <Offcanvas show={show} onHide={onHide} scroll backdrop className="offcanvas-dark" placement="start">
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>メニュー</Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      {/** クリックした時、閉じる */}
      <div onClick={onHide}>
        <NavItems />
      </div>
    </Offcanvas.Body>
  </Offcanvas>
);

/**
 * ヘッダー
 * - サインアウト
 * @returns 
 */
export const Header = ({ onOpenSidebar }) => {
  const { user } = useContext(UserContext);
  const history = useHistory();

  /**
   * サインアウト
   */
  const signOut =  async () => {
    try {
      await Auth.signOut();
      history.push({ pathname: '/', state: { notice: SIGN.OUT.SUCCESS } });
    } catch (e) {
      console.log('error signing out...', e);
    }
  }

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="px-3">
      {/* モバイルで表示するハンバーガーメニュー */}
      <Button variant="outline-light" className="me-3 d-lg-none" onClick={onOpenSidebar} aria-label="open sidebar">
        ☰
      </Button>

      <Nav className="me-auto">
        <Link className="nav-link" to="/dashboard">{user?.username ?? 'Dashboard'}</Link>
      </Nav>
      <Nav>
        <Nav.Link onClick={signOut}>サインアウト</Nav.Link>
      </Nav>
    </Navbar>
  );
}

/**
 * フッター
 * @returns 
 */
export const Footer = () => {
  return (
    <Navbar fixed="bottom" bg="dark" variant="dark" expand="lg">
      <Container className="justify-content-md-center">
        <Navbar.Text>© 2025 Copyright: NSi Moka</Navbar.Text>
      </Container>
    </Navbar>
  );
}
